const messages = {
  en: {
    translations: {
      signup: {
        title: "Sign up",
        toasts: {
          success: "User created successfully! Please login!",
          fail: "Error creating user. Check the reported data.",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
        },
        buttons: {
          submit: "Register",
          login: "Already have an account? Log in!",
        },
      },
      login: {
        title: "Login",
        pharmacyBadge: "Customer care",
        subtitle: "Sign in with your account to continue",
        form: {
          email: "Email",
          password: "Password",
        },
        buttons: {
          submit: "Enter",
          register: "Don't have an account? Register!",
        },
      },
      auth: {
        toasts: {
          success: "Login successfully!",
        },
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Tickets today: ",
          },
        },
        messages: {
          inAttendance: {
            title: "In Service"
          },
          waiting: {
            title: "Waiting"
          },
          closed: {
            title: "Closed"
          }
        }
      },
      connections: {
        title: "Connections",
        toasts: {
          deleted: "WhatsApp connection deleted sucessfully!",
          reconfigured: "The session was reconfigured in WAHA.",
          reconfigureOk: "Session configuration was already correct.",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "Are you sure? It cannot be reverted. The WAHA session will also be deleted.",
          disconnectTitle: "Log out",
          disconnectMessage: "Are you sure? You'll need to link the device again with QR or pairing code.",
          stopTitle: "Stop session",
          stopMessage: "Stop this line? It will stop receiving and sending messages until you restart it.",
        },
        buttons: {
          add: "Add WhatsApp",
          disconnect: "Disconnect",
          tryAgain: "Try Again",
          qrcode: "QR CODE",
          newQr: "New QR CODE",
          connecting: "Connecting",
          login: "Log in",
          restart: "Restart",
          stop: "Stop",
          logout: "Log out",
          reconfigure: "Reconfigure",
          edit: "Edit",
          delete: "Delete",
        },
        forward: {
          optionalMessageLabel: "Optional message",
          optionalMessagePlaceholder: "Type an additional message to send after the forwarded messages",
        },
        toolTips: {
          disconnected: {
            title: "Failed to start WhatsApp session",
            content:
              "Make sure your cell phone is connected to the internet and try again, or request a new QR Code",
          },
          qrcode: {
            title: "Waiting for QR Code read",
            content:
              "Click on 'QR CODE' button and read the QR Code with your cell phone to start session",
          },
          connected: {
            title: "Connection established",
          },
          timeout: {
            title: "Connection with cell phone has been lost",
            content:
              "Make sure your cell phone is connected to the internet and WhatsApp is open, or click on 'Disconnect' button to get a new QRcode",
          },
          error: {
            title: "Session failed",
            content:
              "It will restart automatically while someone is using the CRM. If it does not recover, log out and link again.",
          },
        },
        table: {
          name: "Name",
          status: "Status",
          lastUpdate: "Last Update",
          default: "Default",
          actions: "Actions",
          session: "Session",
        },
      },
      whatsappModal: {
        title: {
          add: "Add WhatsApp",
          edit: "Edit WhatsApp",
        },
        form: {
          name: "Name",
          default: "Default",
          nameHint: "It will be normalized for WAHA (no spaces, accents, or symbols).",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "WhatsApp saved successfully.",
      },
      qrCode: {
        title: "Link WhatsApp",
        message: "Read QrCode to start the session",
        waiting: "Waiting for QR Code…",
        tabs: {
          qr: "QR Code",
          code: "Code",
        },
        codeMessage: "Enter the phone number with country code and request the pairing code.",
        country: "Country",
        phone: "Phone number",
        requestCode: "Request code",
        codeHint: "In WhatsApp: Linked devices → Link with phone number. This method does not use the CRM WA device name (WhatsApp rejects it for pairing codes).",
        invalidPhone: "Enter a valid number (at least 8 digits).",
      },
      contacts: {
        unknownNumber: "No number",
        title: "Contacts",
        toasts: {
          deleted: "Contact deleted sucessfully!",
        },
        searchPlaceholder: "Search by name, phone, email, or ERP client…",
        confirmationModal: {
          deleteTitle: "Delete",
          importTitlte: "Import contacts",
          deleteMessage:
            "Are you sure you want to delete this contact? All related tickets will be lost.",
          importMessage: "Do you want to import all contacts from the phone?",
        },
        buttons: {
          import: "Import Contacts",
          add: "Add Contact",
        },
        table: {
          name: "Name",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Actions",
        },
      },
      contactModal: {
        title: {
          add: "Add contact",
          edit: "Edit contact",
        },
        form: {
          mainInfo: "Contact details",
          extraInfo: "Additional information",
          name: "Name",
          number: "Whatsapp number",
          email: "Email",
          extraName: "Field name",
          extraValue: "Value",
        },
        buttons: {
          addExtraInfo: "Add information",
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Contact saved successfully.",
      },
      quickAnswersModal: {
        title: {
          add: "Add Quick Reply",
          edit: "Edit Quick Answer",
        },
        tabs: {
          text: "Text",
          media: "Media",
          location: "Location",
        },
        form: {
          shortcut: "Shortcut",
          message: "Quick Reply",
          title: "Title (internal)",
          mediaType: "File type",
          mediaFile: "Image / Video / File",
          caption: "Caption or description",
          mapsUrl: "Google Maps URL",
          locationName: "Location name",
          locationCaption: "Description",
        },
        mediaTypes: {
          image: "Image",
          video: "Video",
          file: "File",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Quick Reply saved successfully.",
      },
      queueModal: {
        title: {
          add: "Add queue",
          edit: "Edit queue",
        },
        form: {
          name: "Name",
          color: "Color",
          greetingMessage: "Greeting Message",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
      },
      userModal: {
        title: {
          add: "Add user",
          edit: "Edit user",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
          profile: "Profile",
          whatsapp: "Default Connection",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "User saved successfully.",
      },
      chat: {
        noTicketMessage: "Select a ticket to start chatting.",
      },
      chatPresence: {
        typing: "typing…",
        recording: "recording audio…",
        online: "online",
        lastSeen: "last seen {{time}}",
        minuteAgo: "1 minute ago",
        minutesAgo: "{{count}} minutes ago",
        yesterday: "yesterday",
      },
      ticketsManager: {
        buttons: {
          newTicket: "New",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Queues",
      },
      tickets: {
        toasts: {
          deleted: "The ticket you were on has been deleted.",
        },
        notification: {
          message: "Message from",
        },
        tabs: {
          open: { title: "Inbox" },
          closed: { title: "Resolved" },
          search: { title: "Search" },
        },
        search: {
          placeholder: "Search messages, contacts, or ERP client…",
          typeToSearch: "Type to search messages, contact names, or ERP client.",
          noResults: "No messages found.",
          inChat: "Search in chat",
          contactMatch: "contact",
          contactMatchHint: "Matched by contact or ERP client name",
        },
        buttons: {
          showAll: "All",
        },
      },
      transferTicketModal: {
        title: "Transfer Ticket",
        fieldLabel: "Type to search for users",
        fieldQueueLabel: "Transfer to queue",
        fieldConnectionLabel: "Transfer to connection",
        fieldQueuePlaceholder: "Please select a queue",
        fieldConnectionPlaceholder: "Please select a connection",
        noOptions: "No user found with this name",
        buttons: {
          ok: "Transfer",
          cancel: "Cancel",
        },
      },
      ticketsList: {
        pendingHeader: "Queue",
        assignedHeader: "Working on",
        groupsHeader: "Groups",
        noTicketsTitle: "Nothing here!",
        noTicketsMessage: "No tickets found with this status or search term.",
        connectionTitle: "Connection that is currently being used.",
        buttons: {
          accept: "Accept",
        },
      },
      newTicketModal: {
        title: "Create Ticket",
        fieldLabel: "Search by client, company, or phone",
        add: "Add",
        buttons: {
          ok: "Save",
          cancel: "Cancel",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Connections",
          tickets: "Tickets",
          agentChat: "Agent chat",
          more: "More",
          contacts: "Contacts",
          quickAnswers: "Quick Answers",
          queues: "Queues",
          administration: "Administration",
          users: "Users",
          settings: "Settings",
        },
        appBar: {
          user: {
            profile: "Profile",
            logout: "Logout",
          },
        },
      },
      notifications: {
        noTickets: "No notifications.",
      },
      queues: {
        title: "Queues",
        table: {
          name: "Name",
          color: "Color",
          greeting: "Greeting message",
          actions: "Actions",
        },
        buttons: {
          add: "Add queue",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "Are you sure? It cannot be reverted! Tickets in this queue will still exist, but will not have any queues assigned.",
        },
      },
      queueSelect: {
        inputLabel: "Queues",
      },
      quickAnswers: {
        title: "Quick Answers",
        tabs: {
          all: "All",
          text: "Text",
          media: "Media",
          location: "Location",
        },
        table: {
          type: "Type",
          shortcut: "Shortcut",
          title: "Title",
          message: "Quick Reply",
          actions: "Actions",
        },
        buttons: {
          add: "Add Quick Reply",
        },
        toasts: {
          deleted: "Quick Reply deleted successfully.",
        },
        searchPlaceholder: "Search...",
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete this Quick Reply: ",
          deleteMessage: "This action cannot be undone.",
        },
      },
      users: {
        title: "Users",
        table: {
          name: "Name",
          email: "Email",
          profile: "Profile",
          whatsapp: "Default Connection",
          actions: "Actions",
        },
        buttons: {
          add: "Add user",
        },
        toasts: {
          deleted: "User deleted sucessfully.",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "All user data will be lost. Users' open tickets will be moved to queue.",
        },
      },
      settings: {
        success: "Settings saved successfully.",
        title: "Settings",
        settings: {
          userCreation: {
            name: "User creation",
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
          },
        },
        resolvePending: {
          title: "Queued tickets",
          description: "Mark every pending (queue) ticket as resolved. Group tickets stay open.",
          button: "Resolve pending tickets",
          confirming: "Resolving…",
          confirmTitle: "Resolve all queued tickets",
          confirmMessage: "Resolve every pending ticket? They will be marked resolved. This cannot be undone.",
          success: "{{count}} pending tickets were resolved.",
        },
      },
      ticketInfo: {
        buttons: {
          editClient: "Edit client",
          createClient: "Create client",
        },
      },
      messagesList: {
        header: {
          assignedTo: "Assigned to:",
          buttons: {
            return: "Return",
            resolve: "Resolve",
            reopen: "Reopen",
            accept: "Accept",
          },
        },
        editMessage: "Edit message",
        editMessageDialogTitle: "Edit message",
        editMessageError: "Message can no longer be edited",
        edited: "edited",
        reactToMessage: "React",
        removeReaction: "Remove reaction",
        download: "Download",
        preview: "Preview",
        unavailableMedia: "File unavailable",
      },
      messagesInput: {
        placeholderOpen: "Type a message (Shift+Enter to send). Press ''/'' for quick responses.",
        placeholderClosed: "Reopen or accept this ticket to send a message.",
        signMessage: "Sign",
        audioTooShort: "Recording is too short. Hold the microphone a bit longer.",
        audioMicError: "Could not use the microphone. Check the browser permission and try again.",
        audioUnsupported: "This browser cannot record audio.",
        quickReplyPicker: {
          searchPlaceholder: "Search by title...",
          tabs: {
            all: "All",
            text: "Text",
            media: "Media",
            location: "Location",
          },
          noResults: "No quick replies found",
        },
      },
      contactDrawer: {
        header: "Contact details",
        buttons: {
          edit: "Edit contact",
        },
        extraInfo: "Other information",
      },
      ticketOptionsMenu: {
        delete: "Delete",
        transfer: "Transfer",
        confirmationModal: {
          title: "Delete ticket #",
          titleFrom: "from contact ",
          message: "Attention! All ticket's related messages will be lost.",
        },
        buttons: {
          delete: "Delete",
          cancel: "Cancel",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancel",
        },
      },
      messageOptionsMenu: {
        delete: "Delete",
        reply: "Reply",
        forward: "Forward",
        confirmationModal: {
          title: "Delete message?",
          message: "This action cannot be reverted.",
        },
      },
      forward: {
        titleSelectMessages: "Forward messages",
        titleSelectRecipients: "Select recipients",
        titleSuccess: "Forwarded",
        selectMessagesHint: "Select messages to forward",
        noMessages: "No messages",
        searchHint: "Search by phone, contact name, ERP client, or group",
        searchPlaceholder: "Search...",
        noResults: "No results",
        typeToSearch: "Type to search",
        group: "Group",
        cancel: "Cancel",
        back: "Back",
        forwardSelected: "Forward ({{count}} selected)",
        forwardTo: "Forward to ({{count}} selected)",
        sentSuccess: "Messages forwarded successfully",
      },
      internalChat: {
        title: "Agent chat",
        noChatMessage: "Select a conversation or start a new one.",
        noChatsTitle: "Nothing here!",
        noChatsMessage: "No conversations. Start a direct chat or create a group.",
        buttons: {
          newDM: "New direct chat",
          newGroup: "New group",
          cancel: "Cancel",
          start: "Start",
          create: "Create",
        },
        dmModal: {
          title: "Start direct chat",
          userLabel: "User",
        },
        groupModal: {
          title: "Create group",
          nameLabel: "Group name",
          membersLabel: "Members",
        },
        header: {
          conversation: "Conversation",
        },
        input: {
          placeholder: "Type a message (Shift+Enter to send)",
        },
        searchPlaceholder: "Search conversations...",
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP:
          "There must be at least one default WhatsApp connection.",
        ERR_NO_DEF_WAPP_FOUND:
          "No default WhatsApp found. Check connections page.",
        ERR_WAPP_NOT_INITIALIZED:
          "This WhatsApp session is not initialized. Check connections page.",
        ERR_WAPP_CHECK_CONTACT:
          "Could not check WhatsApp contact. Check connections page.",
        ERR_WAPP_INVALID_CONTACT: "This is not a valid whatsapp number.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Could not download media from WhatsApp. Check connections page.",
        ERR_INVALID_CREDENTIALS: "Authentication error. Please try again.",
        ERR_SENDING_WAPP_MSG:
          "Error sending WhatsApp message. Check connections page.",
        ERR_DELETE_WAPP_MSG: "Couldn't delete message from WhatsApp.",
        ERR_OTHER_OPEN_TICKET:
          "There's already an open ticket for this contact.",
        ERR_SESSION_EXPIRED: "Session expired. Please login.",
        ERR_USER_CREATION_DISABLED:
          "User creation was disabled by administrator.",
        ERR_NO_PERMISSION: "You don't have permission to access this resource.",
        ERR_DUPLICATED_CONTACT: "A contact with this number already exists.",
        ERR_NO_SETTING_FOUND: "No setting found with this ID.",
        ERR_NO_CONTACT_FOUND: "No contact found with this ID.",
        ERR_NO_TICKET_FOUND: "No ticket found with this ID.",
        ERR_NO_USER_FOUND: "No user found with this ID.",
        ERR_NO_WAPP_FOUND: "No WhatsApp found with this ID.",
        ERR_CREATING_MESSAGE: "Error while creating message on database.",
        ERR_CREATING_TICKET: "Error while creating ticket on database.",
        ERR_FETCH_WAPP_MSG:
          "Error fetching the message in WhatsApp, maybe it is too old.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "This color is already in use, pick another one.",
        ERR_WAPP_GREETING_REQUIRED:
          "Greeting message is required if there is more than one queue.",
        ERR_NO_INTERNAL_CHAT_FOUND: "No internal chat found with this ID.",
      },
    },
  },
};

export { messages };
